import { QueryKey } from 'query';

export const USER = 'user';
export const DETAILS = 'details';
export const PERMISSIONS = 'permissions';
export const ACTIVE = 'active';
export const businessKey = new QueryKey(USER);

export const details = businessKey.exact(DETAILS);
export const permissions = businessKey.exact(PERMISSIONS);
export const active = businessKey.exact(ACTIVE);
